import React, { useEffect } from 'react';
import { Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import styles from '../historical/Historical.module.css';

// Import banner image
import bannerImage from '../../../Assets/Image/banner/homee.jpg';

// Import attraction images
import hadarImage from '../../../Assets/Image/Attraction/historical/Allhistory/hadar3.jpg';
import asaitaImage from '../../../Assets/Image/Attraction/historical/Allhistory/Ali Mirah.jpg';
import dallolImage from '../../../Assets/Image/Attraction/historical/Allhistory/saltTrade.jpg';
import triangleImage from '../../../Assets/Image/Attraction/historical/Allhistory/afartriangle.jpg';
import awashImage from '../../../Assets/Image/Attraction/historical/Allhistory/awashVally.jpg';
import abbeImage from '../../../Assets/Image/Attraction/historical/Allhistory/saltTrade.jpg';
import zulaImage from '../../../Assets/Image/Attraction/historical/Allhistory/gulf of zula.jpg';
import ertaAleImage from '../../../Assets/Image/Attraction/historical/Allhistory/ertaAlle.jpg';
import yangudiImage from '../../../Assets/Image/Attraction/historical/Allhistory/yangudipark.jpg';

const Historical = () => {
  const attractions = [
    {
      id: 1,
      title: 'Hadar Archaeological Site',
      description: 'Known worldwide as the cradle of humanity, Hadar is where the famous fossil "Lucy" (Australopithecus afarensis) was discovered. The site holds key evidence of early human ancestors and is crucial for understanding the origins of bipedalism and human evolution.',
      image: hadarImage,
      position: 'left'
    },
    {
      id: 2,
      title: 'Asaita Sultanate',
      description: 'The Sultanate of Asaita, also known as the Aussa Sultanate, played a significant role in the history of the Afar people. It was a center of political power and trade in the region, with the capital at Asaita. The sultanate was established in the 16th century and remained influential for centuries.',
      image: asaitaImage,
      position: 'right'
    },
    {
      id: 3,
      title: 'Dallol Salt Trade Heritage',
      description: 'Dallol is not only known for its surreal landscapes but also for its historical significance as a center of the ancient salt trade. For centuries, Afar salt miners have been extracting salt from the vast plains of Dallol using traditional methods, preserving a rich cultural heritage.',
      image: dallolImage,
      position: 'left'
    },
    {
      id: 4,
      title: 'Afar Triangle',
      description: 'Located in northeastern Ethiopia and western Djibouti, the Afar Triangle features below sea level deserts, towering escarpments, fissures, volcanoes, salt lakes and craters. This region contains the Danakil depression, one of the lowest points in Africa, fed by the Awash River.',
      image: triangleImage,
      position: 'right'
    },
    {
      id: 5,
      title: 'Awash Valley Sites',
      description: 'The Awash Valley houses several significant archaeological sites, including Middle Awash and Gona. This region contains ancient fossil remains and evidence of early human life, including some of the oldest stone tools ever discovered.',
      image: awashImage,
      position: 'left'
    },
    {
      id: 6,
      title: 'Lake Abbe',
      description: 'Lake Abbe holds both scenic beauty and cultural significance for the Afar people. For centuries, it has been associated with ancient traditions and legends. Its unique landscape of limestone chimneys and position on ancient trade routes highlight its historical importance.',
      image: abbeImage,
      position: 'right'
    },
    {
      id: 7,
      title: 'Gulf of Zula',
      description: 'The Gulf of Zula, or Annesley Bay, was home to the ancient port of Adulis. This historic port facilitated trade between the Kingdom of Aksum and other regions, enabling the exchange of ivory, spices, and textiles between Africa, Arabia, and India.',
      image: zulaImage,
      position: 'left'
    },
    {
      id: 8,
      title: 'Erta Ale Volcano',
      description: 'The Erta Ale Volcano region holds deep cultural significance to the Afar people, influencing local myths, legends, and traditions. The volcano is revered within Afar culture, contributing to the region\'s intangible heritage.',
      image: ertaAleImage,
      position: 'right'
    },
    {
      id: 9,
      title: 'Yangudi-Rassa National Park',
      description: 'Beyond its wildlife significance, Yangudi-Rassa National Park embodies the historical and cultural values of the Afar people. The park area demonstrates the deep connection between the Afar people and their environment, preserved through centuries.',
      image: yangudiImage,
      position: 'left'
    }
  ];

  useEffect(() => {
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.3
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('active');
        }
      });
    }, observerOptions);

    const sections = document.querySelectorAll('.attraction-section');
    sections.forEach(section => observer.observe(section));

    return () => {
      sections.forEach(section => observer.unobserve(section));
    };
  }, []);

  return (
    <div className={styles.attractionsNew}>
      <div 
        className={styles.heroBanner}
        style={{ backgroundImage: `url(${bannerImage})` }}
      >
        <div className={styles.heroContent}>
          <h1>All Natural Wonders of Afar</h1>
          <p>Discover the ancient heritage and cultural richness of the Afar region</p>
        </div>
      </div>

      <Container fluid>
        {attractions.map((attraction) => (
          <div 
            key={attraction.id} 
            className={`${styles.attractionSection} ${attraction.position === 'right' ? styles.right : ''}`}
          >
            <div className={styles.attractionContent}>
              {attraction.position === 'left' ? (
                <>
                  <div className={styles.attractionImage}>
                    <img src={attraction.image} alt={attraction.title} />
                    <div className={styles.imageOverlay}></div>
                  </div>
                  <div className={styles.attractionInfo}>
                    <h2>{attraction.title}</h2>
                    <p>{attraction.description}</p>
                    <button className={styles.exploreBtn}>Explore More</button>
                  </div>
                </>
              ) : (
                <>
                  <div className={styles.attractionInfo}>
                    <h2>{attraction.title}</h2>
                    <p>{attraction.description}</p>
                    <button className={styles.exploreBtn}>Explore More</button>
                  </div>
                  <div className={styles.attractionImage}>
                    <img src={attraction.image} alt={attraction.title} />
                    <div className={styles.imageOverlay}></div>
                  </div>
                </>
              )}
            </div>
          </div>
        ))}
      </Container>
    </div>
  );
};

export default Historical;